export default function(text, options = {}) {
  const flashEvent = new CustomEvent("application:notify", { detail: { text, options }, bubbles: false })
  global.dispatchEvent(flashEvent)
}
